const commentImageSrc =
  /(\bsrc\s*=\s*["'])(?:https?:\/\/[^"'\s]*?)?(\/fileSystemServer\/getCommentImage\/)/gi;

export const stripCommentImageHost = (html: string) =>
  html.replace(commentImageSrc, "$1$2");

export const withCommentImageHost = (html: string, backendUrl: string) => {
  const origin = backendUrl.replace(/\/+$/, "");
  return html.replace(
    commentImageSrc,
    (_, attr: string, path: string) => `${attr}${origin}${path}`,
  );
};
